import { useTranslation } from 'react-i18next';

// Steaguri SVG inline — nu depind de emoji (unicod. inconsistent între OS-uri).
const FlagRO = ({ className = 'w-5 h-4' }) => {
  const { t } = useTranslation();
  return (
    <svg
      className={className}
      viewBox="0 0 30 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={t('language.flagRoAlt')}
    >
      <rect width="10" height="20" x="0" y="0" fill="#002B7F" />
      <rect width="10" height="20" x="10" y="0" fill="#FCD116" />
      <rect width="10" height="20" x="20" y="0" fill="#CE1126" />
    </svg>
  );
};

const FlagEN = ({ className = 'w-5 h-4' }) => {
  const { t } = useTranslation();
  return (
    <svg
      className={className}
      viewBox="0 0 60 30"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={t('language.flagEnAlt')}
    >
      <clipPath id="s">
        <path d="M0,0 v30 h60 v-30 z" />
      </clipPath>
      <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" clipPath="url(#s)" />
      <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#s)" stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" clipPath="url(#s)" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" clipPath="url(#s)" />
    </svg>
  );
};

const LanguageSwitcher = ({ compact = false }) => {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.startsWith('en') ? 'en' : 'ro';

  const change = (lang) => {
    if (lang === current) return;
    i18n.changeLanguage(lang);
  };

  if (compact) {
    // Variantă compactă — un buton care arată doar steagul limbii opuse (click = schimbă)
    const other = current === 'ro' ? 'en' : 'ro';
    const OtherFlag = other === 'ro' ? FlagRO : FlagEN;
    return (
      <button
        type="button"
        onClick={() => change(other)}
        title={t('language.switchTo')}
        className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 transition text-sm text-slate-700 dark:text-slate-300"
      >
        <OtherFlag />
        <span className="font-medium uppercase">{other}</span>
      </button>
    );
  }

  // Variantă expandată — ambele steaguri alăturate, cel activ evidențiat
  return (
    <div
      className="inline-flex items-center gap-1 bg-slate-100 dark:bg-slate-800 rounded-lg p-1"
      role="radiogroup"
      aria-label={t('language.switchTo')}
    >
      <button
        type="button"
        onClick={() => change('ro')}
        aria-checked={current === 'ro'}
        role="radio"
        title={t('language.ro')}
        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold transition ${
          current === 'ro'
            ? 'bg-white dark:bg-slate-800 shadow-sm text-slate-900 dark:text-slate-100'
            : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'
        }`}
      >
        <FlagRO />
        RO
      </button>
      <button
        type="button"
        onClick={() => change('en')}
        aria-checked={current === 'en'}
        role="radio"
        title={t('language.en')}
        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold transition ${
          current === 'en'
            ? 'bg-white dark:bg-slate-800 shadow-sm text-slate-900 dark:text-slate-100'
            : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'
        }`}
      >
        <FlagEN />
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
